import api from '../api.js';

/**
 * Destaca células de saldo simulado / situação no Pedido de Saída.
 * @param {Element|null} root
 */
export function paintOutputOrderSimCells(root)
{
	if (!root)
		return;
	root.querySelectorAll('.sial-items-scroll tr.row').forEach((row) =>
	{
		const sitEl = row.querySelector('[id^="stock_situation-"]');
		const simEl = row.querySelector('[id^="simulated_available_quantity-"]');
		const sit = String(sitEl?.value || '').trim();
		const cls = sit === 'SALDO_SIMULADO_NEGATIVO' ? 'oo-sim-neg'
			: (sit === 'ATENCAO' || sit === 'VENCIMENTO_CRITICO') ? 'oo-sim-warn'
			: '';
		row.querySelectorAll('td.oo-col-sim, td.oo-col-sit').forEach((td) =>
		{
			td.classList.remove('oo-sim-neg', 'oo-sim-warn');
			if (cls)
				td.classList.add(cls);
		});
		if (simEl && (simEl.value === '' || simEl.value == null) && sitEl && !sit)
		{
			/* vazio: deixa — */
		}
	});
}

function _fmtQty(v)
{
	if (v == null || v === '')
		return '';
	const n = Number(v);
	if (!isFinite(n))
		return '';
	return String(n);
}

/**
 * Recalcula Pré-reserva / Saldo sim. / Situação das linhas do Pedido de Saída,
 * respeitando o programa do cabeçalho (estoque do lote filtrado por program_id).
 * @param {Element|null} root
 * @param {{ companyId?: string|null, programId?: number|null }} [opts]
 */
export async function refreshOutputOrderSimStock(root, opts = {})
{
	if (!root)
		return;
	const companyId = opts.companyId
		|| root.querySelector?.('#company_id')?.getAttribute?.('data-value')
		|| null;
	let programId = opts.programId;
	if (programId === undefined)
	{
		const raw = root.querySelector?.('#program_id')?.getAttribute?.('data-value')
			?? root.querySelector?.('#program_id')?.value;
		const n = Number(raw);
		programId = Number.isInteger(n) && n > 0 ? n : null;
	}
	const tbody = root.querySelector('.sial-items-scroll tbody');
	if (!tbody || !companyId)
		return;
	const productIds = [];
	const rowMeta = [];
	tbody.querySelectorAll('tr.row').forEach((row) =>
	{
		const prodEl = row.querySelector('[id^="product_id-"]');
		if (!prodEl)
			return;
		const n = (prodEl.id.match(/\d+$/) || ['0'])[0];
		const dataVal = prodEl.getAttribute('data-value');
		let pid = dataVal != null && String(dataVal).trim() !== '' ? Number(dataVal) : NaN;
		if (!Number.isInteger(pid) || pid <= 0)
		{
			const raw = String(prodEl.value || '').trim();
			if (/^\d+$/.test(raw))
				pid = Number(raw);
		}
		if (!Number.isInteger(pid) || pid <= 0)
			return;
		productIds.push(pid);
		rowMeta.push({ n, pid });
	});
	const unique = [...new Set(productIds)];
	if (!unique.length)
	{
		rowMeta.forEach(({ n }) =>
		{
			const pre = root.querySelector(`#pre_reserved_by_approved_orders-${n}`);
			const sim = root.querySelector(`#simulated_available_quantity-${n}`);
			const sit = root.querySelector(`#stock_situation-${n}`);
			if (pre) pre.value = '';
			if (sim) sim.value = '';
			if (sit) sit.value = '';
		});
		paintOutputOrderSimCells(root);
		return;
	}
	let q = `?product_ids=${unique.join(',')}&include_zero_stock=1&per_page=${Math.max(100, unique.length)}`;
	if (programId != null)
		q += `&program_id=${programId}`;
	let avail = null;
	try
	{
		if (typeof api.list_stocks_simulated_availability === 'function')
			avail = await api.call(api.list_stocks_simulated_availability, companyId, q);
	}
	catch (_e)
	{
		avail = null;
	}
	const byPid = new Map();
	for (const row of (avail?.items || []))
	{
		if (row?.product_id != null)
			byPid.set(Number(row.product_id), row);
	}
	for (const { n, pid } of rowMeta)
	{
		const row = byPid.get(pid);
		const pre = root.querySelector(`#pre_reserved_by_approved_orders-${n}`);
		const sim = root.querySelector(`#simulated_available_quantity-${n}`);
		const sit = root.querySelector(`#stock_situation-${n}`);
		if (!row)
		{
			if (pre) pre.value = '';
			if (sim) sim.value = _fmtQty(0);
			if (sit) sit.value = programId != null ? 'SEM_SALDO_PROGRAMA' : '';
			continue;
		}
		if (pre) pre.value = _fmtQty(row.pre_reserved_by_approved_orders);
		if (sim) sim.value = _fmtQty(row.simulated_available_quantity);
		if (sit) sit.value = row.status || '';
	}
	paintOutputOrderSimCells(root);
}
